<template>
  <div>
    <el-card>
      <h3 class="title">添加方式</h3>
      <el-form label-position="left" ref="ruleForm" :rules="rules" :model="addTypeData" :disabled="disabledFlag">
        <el-form-item
        label="添加方式"
        label-width="120px"
        prop="addType">
          <el-col :span="12">
            <el-select
              v-model="addTypeData.addType"
              placeholder="请选择添加方式"
              style="width: 100%;">
              <el-option
                v-for="item in addType"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- 添加文件 -->
        <el-row v-for="(item,index) in addTypeData.guideStepInfoDtoList" :key="index" class="step-wrap">
          <el-form-item
            :label="`第${index+1}步`"
            label-width="120px">
            <el-col :span="12">
              <!-- <el-row>
                <el-form-item
                  label="图片标题"
                  label-width="120px">
                  <el-input
                     maxlength="20"
                    v-model.trim="item.picTitle"
                    placeholder="请输入图片标题"
                  />
                </el-form-item>
              </el-row> -->
              <el-row class="marT20">
                <el-form-item
                  :prop="'guideStepInfoDtoList.'+index+'.picToken'"
                  :rules="rules.picToken"
                  label-width="120px">
                    <el-row slot="label">
                      <span class="name">上传图片</span>
                      <el-tooltip content="引导页步骤展示图片" placement="top" effect="light">
                        <span class="el-icon-question" style="margin-left: 10px"></span>
                      </el-tooltip>
                    </el-row>
                    <el-row class="img-box">
                      <el-row type="flex" justify="space-between">
                        <!-- <el-input
                          :readonly="true"
                          style="width:80%"
                          placeholder="图片支持jpeg、jpg、png格式，大小5M内"
                          v-model="item.picName">
                        </el-input> -->
                        <el-upload
                          ref="upload"
                          name="file"
                          list-type="picture-card"
                          :file-list="item.guideStepImageDtoList"
                          action="/api/paas-platform/file-service/v1/file/upload/fileUpload"
                          accept="image/jpg,image/jpeg,image/png"
                          :before-upload="beforeUp"
                          :data="imgParams"
                          :on-success="(res,file)=>{handleAvatarSuccess(index,res,file)}"
                          :before-remove="(file, fileList) => handleRemove(index, file, fileList)"
                        >
                          <!-- :on-change="handleChange" -->
                          <!-- <el-button icon="el-icon-upload2">上传文件</el-button> -->
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </el-row>
                      <!-- <el-image
                        v-if="item.picUrl !== ''"
                        style="width: 100px; height: 100px"
                        :src="item.picUrl"
                        :preview-src-list="[item.picUrl]"></el-image> -->

                      <!-- <el-image
                        v-if="item.guideStepImageDtoList.length !== 0"
                        style="width: 100px; height: 100px"
                        :src="item.picUrl"
                        :preview-src-list="item.guideStepImageDtoList"></el-image> -->
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row class="marT20">
                <!--<div class="desTitle" style="vertical-align: top;">提示文字</div>-->
                <el-form-item
                  :prop="'guideStepInfoDtoList.'+ index +'.picDesc'"
                  :rules="rules.picDesc"
                  label-width="120px">
                  <el-row slot="label">
                    <span class="name">提示文字</span>
                    <el-tooltip content="引导页步骤提示语" placement="top" effect="light">
                      <span class="el-icon-question" style="margin-left: 10px"></span>
                    </el-tooltip>
                  </el-row>
                  <el-input
                    :autosize="{ minRows: 3, maxRows: 3}"
                    v-model="item.picDesc"
                    :maxlength="255"
                    type="textarea"
                    placeholder="文字限制255个字符内"
                    class="add1TextArea"/>
                </el-form-item>
              </el-row>
            </el-col>
          </el-form-item>
          <el-row class="marT20 delete" @click.native="deleteItem(item,index)" v-if="(index !== 0 && index !== 1 ) && addTypeData.guideStepInfoDtoList.length > 1&& selStatus !== 'view' ">
            {{`删除第${index+1}步`}}
          </el-row>
        </el-row>

      </el-form>
      <div class="add" :style="addTypeData.guideStepInfoDtoList.length === 2?'bottom:40px':'bottom:100px'" v-if="addTypeData.guideStepInfoDtoList.length<5">
        <el-tooltip content="最多不超过5条" placement="top" effect="light">
          <i @click="addItem" class="el-icon-plus avatar-uploader-icon" v-if="!disabledFlag"/>
        </el-tooltip>
      </div>
    </el-card>
  </div>
</template>
<script>

export default {
  props: {
    addTypeData: {
      type: Object
    },
    disabledFlag: {
      type: Boolean
    },
    selStatus: {
      type: String
    },
    allImgList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      imgParams: {
        dir: 'appGuide/img'
      },
      rules: {
        addType: [{ required: true, message: '请选择添加方式', trigger: 'change' }],
        // picTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        picDesc: [{ required: true, message: '请输入提示文字', trigger: 'blur' }],
        // picToken: [{ required: true, message: '请选择图片', trigger: 'change' }]
      },
      addType: [
        {
          value: 0,
          label: 'DLNA'
        },
        {
          value: 1,
          label: '自发现方式'
        },
        {
          value: 2,
          label: '短按入网键方式'
        },
        {
          value: 3,
          label: '二维码'
        },
        {
          value: 4,
          label: '云云对接'
        },
        {
          value: 5,
          label: 'Auth2.0对接'
        }
      ]
    }
  },
  watch: {
    selStatus: {
      handler (val) {
        console.log(val)
      },
      immediate: true
    }
  },
  created () {
    this.addTypeData.guideStepInfoDtoList.forEach(item => {
      item.guideStepImageDtoList.forEach(itemJ => {
        let {picName, picUrl} = itemJ;
        itemJ.name = picName
        itemJ.url = picUrl
      })
    });
  },
  methods: {
    handleChange (selFile, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      // this.addTypeData.guideStepInfoDtoList.fileList = fileList
    },
    handleRemove (index, file, fileList) {
      let picToken = file.picToken;
      let xx = this.addTypeData.guideStepInfoDtoList;
      debugger;
      let imgs = this.addTypeData.guideStepInfoDtoList[index].guideStepImageDtoList;
      let res = imgs.filter(img => img.picToken != picToken);
      this.addTypeData.guideStepInfoDtoList[index].guideStepImageDtoList = res;


      // let pathKey = file.response.data.pathKey;
      // let imgs = this.addTypeData.guideStepInfoDtoList[index].guideStepImageDtoList;
      // let res = imgs.filter(img => img.picToken != pathKey);
      // this.addTypeData.guideStepInfoDtoList[index].guideStepImageDtoList = res;
    },
    deleteItem (item, index) {
      /* if (this.selStatus === 'edit') {
        item.flag = 1
      } else {
        this.addTypeData.guideStepInfoDtoList.splice(index, 1)
      } */
      const list = JSON.parse(JSON.stringify(this.addTypeData.guideStepInfoDtoList))
      list.splice(index, 1)
      this.addTypeData.guideStepInfoDtoList = list
    },
    addItem () {
      if (this.selStatus === 'edit') {
        this.addTypeData.guideStepInfoDtoList.push({
          picId: null,
          stepId: null,
          // picTitle: '', // 标题
          // picToken: '', // 文件key
          picDesc: '', // 步骤提示语
          stepOrder: this.addTypeData.guideStepInfoDtoList.length + 1, // 步骤顺序
          stepName: `第${this.addTypeData.guideStepInfoDtoList.length + 1}步`, // 步骤名称
          // picName: '',
          // picUrl: '',
          guideStepImageDtoList: [],
          itemId: new Date().valueOf()
        })
      } else {
        this.addTypeData.guideStepInfoDtoList.push({
          // picTitle: '', // 标题
          // picToken: '', // 文件key
          picDesc: '', // 步骤提示语
          stepOrder: this.addTypeData.guideStepInfoDtoList.length + 1, // 步骤顺序
          stepName: `第${this.addTypeData.guideStepInfoDtoList.length + 1}步`, // 步骤名称
          // picName: '',
          // picUrl: '',
          guideStepImageDtoList: [],
          itemId: new Date().valueOf()
        })
      }
    },
    handleAvatarSuccess (num, res, file) {
      console.log(num, res, file)
      if (res.code !== 200) {
        this.$message.error('上传出错，请重新上传')
        return
      }
      let picData = {
        picUrl: res.data.fileUrl,
        picToken: res.data.pathKey,
        picName: file.name,
        name: file.name,
        url: res.data.fileUrl,
      }
      this.addTypeData.guideStepInfoDtoList[num].guideStepImageDtoList.push(picData)
      // this.addTypeData.guideStepInfoDtoList[num].picUrl = res.data.fileUrl
      // this.addTypeData.guideStepInfoDtoList[num].picToken = res.data.pathKey
      // this.addTypeData.guideStepInfoDtoList[num].picName = file.name
      this.allImgList.push(res.data.pathKey)
    },
    beforeUp (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$message.error('上传文件只能是图片格式！')
        return false
      }
      if (file.size / 1024 / 1024 >= 5) {
        this.$message.error('请上传5M以内的图片！')
        return false
      }
      return true
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-form-item__label{
  display:flex;
  align-items: center !important;
}
.el-card{
  padding: 14px;
  position: relative;
}
/deep/ .el-card__body{
  padding: 0;
}
.title{
  width: 10%;
  padding: 5px 5px 5px 0;
  display: inline-block;
  margin-bottom: 10px;
  border-bottom: 1px solid #e6e2e2;
}
.step-wrap{
  margin-top: 10px;
  box-sizing: border-box;
  .marT20{
    margin-top: 20px;
  }
  .delete{
    display: inline-block;
    padding-bottom: 20px;
    color: red;
    cursor: pointer;
    border-bottom: 1px solid #f3f3f3;
  }
}
.img-box{
  display: flex;
  flex-direction: column;
  .el-image{
    margin-top: 20px;
  }
}
.add{
  display: inline-block;
  position: absolute;
  right: 35%;
  bottom: 80px;
  .avatar-uploader-icon {
    font-size: 14px;
    color:white;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color:#409EFF;
    border-radius: 25px;
    cursor: pointer;
  }
}
</style>
